var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialDoNotDisturbAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.824,
    height: 8.824,
    viewBox: "0 0 8.824 8.824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.412 0a4.412 4.412 0 104.412 4.412A4.425 4.425 0 004.412 0zM.882 4.412a3.54 3.54 0 013.53-3.53 3.477 3.477 0 012.162.75L1.633 6.574a3.477 3.477 0 01-.751-2.162zm3.53 3.53a3.477 3.477 0 01-2.162-.75L7.192 2.25a3.477 3.477 0 01.75 2.162 3.54 3.54 0 01-3.53 3.53z",
    fill: "#9d9c9c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialDoNotDisturbAlt);
export default __webpack_public_path__ + "static/media/material-do-not-disturb-alt.3f354e9e.svg";
export { ForwardRef as ReactComponent };